<template>
<transition name='fade'>
 <div class="ad-module" v-if="list.length">
        <div v-for="(item,index) in list"  :key="index" v-if="item.dt.length" :class="['ad-'+type[index]]" :ref="index==0?'adFloat':''" >
            <template >
             <div class="close-btn" @click="close">
                <i class="el-icon-error"></i>
            </div>
            <div class="ad-content"  v-html="item.dt[0].context">
            </div>
            </template>
        </div>

    </div>
</transition>
   
</template>

<script>
import floatAd from '@/utils/floatAd.js'
export default {
    data(){
        return{
            type:['float','left','right'],
            list:[]
        }
    },
    methods: {
      close(even) {
        const removeItem = even.currentTarget.parentNode
            removeItem.parentNode.removeChild(removeItem)
        },
    },
    mounted(){
         //浮动，左侧，右侧
        this.getColumn({typeId:'port3001,port3002,port3003',rowNum:'1,1,1',contextFlg:'2'}).then(result=>{
            this.list=result
            setTimeout(() => {
                this.$refs['adFloat']&&floatAd(this.$refs['adFloat'][0])
               
            }, 20);
        })
    },

}
</script>

<style lang="scss">
.ad-module{
    .ad-float{
        z-index: 9999;
    }
    .ad-left {
    position: fixed;
     z-index: 999;
    left: 20px;
    top: 10px;
  }
  .ad-right {
    position: fixed;
     z-index: 999;
    right: 20px;
    top: 10px;
  }
   .close-btn {
      top: 0;
      right: 0;
      cursor: pointer;
      opacity: .2;
      position: absolute;
      &:hover {
        opacity: 1
      }
    }
}

</style>
